import { useEffect, useState } from "react";
import { CardSection } from "../../../components/CardSection";
import { LineGraph } from "../../../components/Graph/LineGraph";
import { API } from "../../../apis/dashboard.api";
import { StyledSection2 } from "./style";

import useRegionStore from "../../../store/useRegionStore";

export const Section2 = () => {
  const { selectedRegion } = useRegionStore();
  const [yearsList, setYearsList] = useState();
  const [monthlyPotholeData, setMonthlyPotholeData] = useState();

  const convertMonthlyList = (data) => {
    const monthList = [
      { month: "1월" },
      { month: "2월" },
      { month: "3월" },
      { month: "4월" },
      { month: "5월" },
      { month: "6월" },
      { month: "7월" },
      { month: "8월" },
      { month: "9월" },
      { month: "10월" },
      { month: "11월" },
      { month: "12월" },
    ];

    for (let key in data) {
      const index = monthList.findIndex((list) => list.month === `${key}월`);
      if (index !== -1) {
        monthList[index] = {
          ...monthList[index],
          ...data[key],
        };
      }
    }
    return monthList;
  };

  const getData = async () => {
    if (yearsList) {
      try {
        let monthlyPothole = {};

        const apiPromises = yearsList.map(async (year) => {
          const results = await API.getMonthlyPotholeCount({
            year: year,
            departmentId: selectedRegion,
          });

          if (await results) {
            for (let result of results) {
              const key = Object.keys(result)[0];
              monthlyPothole = {
                ...monthlyPothole,
                [key]: {
                  ...monthlyPothole[key],
                  [year]: convertMonthlyList(result[key]),
                },
              };
            }
          }
        });

        await Promise.all(apiPromises).then(() => {
          setMonthlyPotholeData(monthlyPothole);
        });
      } catch (e) {}
    }
  };

  useEffect(() => {
    getData();
  }, [selectedRegion]);

  useEffect(() => {
    const currentYear = new Date().getFullYear();
    const yearsArray = [];
    for (let year = 2023; year <= currentYear; year++) {
      yearsArray.push(year.toString());
    }
    setYearsList(yearsArray);
  }, []);

  return (
    <StyledSection2>
      <div
        className="section2-container"
        style={{
          padding: !Object.keys(monthlyPotholeData || {}).length ? "0" : "",
        }}
      >
        {monthlyPotholeData &&
          Object.keys(monthlyPotholeData).map((key, index) => (
            <CardSection
              key={index}
              title={`${key} 월별 포트홀 검수 현황`}
              icon="Histogram"
            >
              <LineGraph
                data={monthlyPotholeData[key]}
                xKey="month"
                yKey={[
                  {
                    key: "repairedPthCnt",
                    label: "보수된 포트홀 개수",
                  },
                  {
                    key: "detectedPthCnt",
                    label: "검출된 포트홀 개수",
                  },
                ]}
                yLabel="개수"
                unit="개"
                multiGraphMode={true}
              />
            </CardSection>
          ))}
      </div>
    </StyledSection2>
  );
};
